<template>
  <div class="listObs">
    <h3 class="listObs__title">
      {{ $t('layout.observations.listOf') }}
      <button
        id="label-listObsDrawer"
        v-tooltip.right="toggleTooltipListObs"
        class="arrowObsResult inline"
        @click="toggleListObs()"
      >
        <IconWrap label="listObsDrawer">
          <IconArrow />
        </IconWrap>
      </button>
    </h3>
    <p
      v-if="listObsDrawer.opened && loadedObsToDisplay.length < 1"
      class="pb-6 px-8"
    >
      {{ $t('layout.observations.noObs') }}
    </p>
    <ul
      v-if="(listObsDrawer.opened)"
    >
      <li
        v-for="(obs, index) in loadedObsToDisplay"
        :key="'obs'+index"
        class="listObs__item"
        :class="{ 'listObs__item--private': obs.state === 'created'}"
        @mouseenter="addSelectColor(index)"
        @mouseleave="removeSelectColor(index)"
      >
        <h3
          class="listObs__observation"
          @mouseenter="e => isEllipsisActive(e) ? e.target.classList.add('listObs__observation--expandable') : null"
          @click="e => e.target.classList.toggle('listObs__observation--expanded')"
        >
          {{ obs.observation }}
        </h3>

        <!-- If the observation is from the user but wasn't valide yet (the owner of the observation is the only one to be able to see/edit it) -->
        <span
          v-if="obs.state === 'created'"
          v-tooltip.top="$t('layout.observations.notValidatedYet')"
          class="italic text-gray-400"
        >{{ $t('generic.access.private') }}</span>
        <div>
          <button
            v-if="editAccess(obs.volunteer.id)"
            id="label-editObs"
            v-tooltip.top="$t('layout.observations.edit')"
            @click="editObs(index)"
          >
            <IconWrap
              label="editObs"
              width="14"
              height="14"
            >
              <IconEdit />
            </IconWrap>
          </button>
          <button
            v-if="editAccess(obs.volunteer.id)"
            id="label-deleteObs"
            v-tooltip.top="$t('layout.observations.delete')"
            @click="deleteObs({ imageId, index })"
          >
            <IconWrap
              label="deleteObs"
              width="16"
              height="16"
            >
              <IconDelete />
            </IconWrap>
          </button>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';

import IconDelete from '@/assets/images/icons/Bin';
import IconEdit from '@/assets/images/icons/Pencil';
import IconWrap from '@/assets/images/icons';
import IconArrow from '@/assets/images/icons/Arrow';

export default {
  name: 'ObservationsList',

  components: {
    IconWrap,
    IconArrow,
    IconEdit,
    IconDelete
  },

  props: {
    imageId: {
      type: Number,
      default: () => null
    }
  },

  computed: {

    toggleTooltipListObs() {
      return this.listObsDrawer.opened ? this.$t('layout.observations.hideListOf') : this.$t('layout.observations.showListOf');
    },

    ...mapState('user', ['userInfo']),
    ...mapState('observations', ['listObsDrawer']),
    ...mapGetters('observations', ['loadedObsToDisplay', 'viewingObs'])
  },

  methods: {
    isEllipsisActive(e) {
      return e.target.offsetWidth < e.target.scrollWidth;
    },

    editAccess(userId) {
      return userId === this.userInfo.id;
    },

    addSelectColor(index) {
      if (document.getElementById('obsSelection-' + index)) {
        document.getElementById('obsSelection-' + index).classList.add('rect-observation--selected');
      }
    },

    removeSelectColor(index) {
      if (document.getElementById('obsSelection-' + index)) {
        document.getElementById('obsSelection-' + index).classList.remove('rect-observation--selected');
      }
    },

    ...mapActions('observations', ['viewObs', 'editObs', 'deleteObs', 'toggleListObs'])
  }
};
</script>

<style lang="postcss">
.listObs{
  @apply py-6;
}

.listObs__title{
  @apply py-4 px-8 text-lg font-semibold border-gray-100 border-t border-solid;
}

.listObs__item {
  @apply flex items-center justify-between px-8 py-3 border-gray-100 border-t border-solid;
  border-left:10px solid transparent;
  &:last-child{
    @apply border-b border-solid;
    border-bottom-color:theme('colors.gray.100');
  }
  &:hover{
    @apply bg-gray-50;
    border-left-color:theme('colors.orange.100');
  }
  & button{
    @apply invisible mr-4;
  }
  & button:last-child{
    @apply mr-0;
  }
  &:hover button{
    @apply visible;
  }
}

.listObs__observation{
  @apply w-full text-left text-base font-body leading-none;
  text-overflow: ellipsis;
  max-width: 60%;
  &.listObs__observation--expandable{
    cursor:pointer;
  }
  &:not(.listObs__observation--expanded){
    @apply overflow-hidden inline-block whitespace-no-wrap ;
  }
}

.listObs__item--private{
  border-left-color:theme('colors.gray.100');
  & button {
    @apply text-gray-200;
  }
}

.arrowObsResult{
  @apply ml-2;
  transform: rotate(180deg);
}
</style>
